// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"a3ed80bf","255":"64e009a9","263":"a143a346","496":"54ee21e4"}[chunkId] + ".chunk.js";
};